export async function createTheme(categoryNr, properties) {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}themes/category/${categoryNr}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties),
    });

    if (response.ok) return response.json();

    throw response;
}
